import * as models from '../../models';

export const aircraftCategories = [
  {
    id: 13,
    name: 'Helicopter'
  },
  {
    id: 1,
    name: 'Piston',
  },
  {
    id: 2,
    name: 'Turbo Prop'
  },
  {
    id: 3,
    name: 'Entry Level Jet (VLJ)'
  },
  {
    id: 4,
    name: 'Light Jet'
  },
  {
    id: 5,
    name: 'Mid Size Jet'
  },
  {
    id: 6,
    name: 'Super Mid Size Jet'
  },
  {
    id: 7,
    name: 'Heavy Jet'
  },
  {
    id: 8,
    name: 'Ultra Long Range'
  },
  {
    id: 9,
    name: 'Airliner',
  },
  {
    id: 10,
    name: 'VIP Airliner',
  }
] as Array<models.AircraftCategory>;
